const productPhoneMap = new Map([
  ["Esbriet", "(877) 780-4958"],
  ["Evrysdi", "(800) 636-0316"],
  ["ENSPRYNG", "(800) 636-0373"],
  ["HEMLIBRA", "(844) 436-2672"],
  ["OCREVUS", "(844) 672-6729"],
  ["Pulmozyme", "(877) 794-8723"],
  ["XOLAIR", "(855) 965-2472"],
  ["Actemra Intravenous", "(855) 722-6729"],
  ["Actemra Subcutaneous", "(855) 722-6729"],
  ["Rituxan for Immunology", "(855) 722-6729"],
  ["Alecensa", "(855) 692-6729"],
  ["Avastin", "(855) 692-6729"],
  ["Columvi", "(855) 692-6729"],
  ["Cotellic", "(855) 692-6729"],
  ["Erivedge", "(855) 692-6729"],
  ["Gavreto", "(855) 692-6729"],
  ["Gazyva", "(855) 692-6729"],
  ["Herceptin", "(855) 692-6729"],
  ["Herceptin Hylecta", "(855) 692-6729"],
  ["Kadcyla", "(855) 692-6729"],
  ["Lunsumio", "(855) 692-6729"],
  ["Perjeta", "(855) 692-6729"],
  ["Phesgo", "(855) 692-6729"],
  ["Polivy", "(855) 692-6729"],
  ["Rituxan Hycela", "(855) 692-6729"],
  ["Rituxan for Oncology", "(855) 692-6729"],
  ["Rozlytrek", "(855) 692-6729"],
  ["Tecentriq", "(855) 692-6729"],
  ["Venclexta", "(855) 692-6729"],
  ["Zelboraf", "(855) 692-6729"],
  ["Lucentis", "(855) 218-5307"],
  ["Susvimo", "(855) 218-5307"],
  ["Vabysmo", "(855) 218-5307"]
]);
export const getPhoneByProductName = (drugName) => {
  drugName = drugName.toLowerCase();
  for (const [product, phone] of productPhoneMap.entries()) {
    if (product.toLowerCase().includes(drugName)) {
      return phone;
    }
  }
  return null;
};
